<!-- <div class="main-notification hidden" #notification> -->
  <div [ngClass]="['main-notification hidden', showTopBanner ? 'with-top-banner' : '']" #notification>
  {{notificationMessage}}
</div>